import gsap from "gsap";

(function ($) {
    $(document).ready(function () {

        const section = $(".section-statistic");

        gsap.from(section, {
            scrollTrigger: {
                start: "top center",
                end: "bottom center",
                trigger: section,
                onEnter: () => {
                    handleAnim()
                }
            }
        });

        $(window).on("resize load", () => {
            if (section.find(".grid-row").offset().top > $(window).height()) {
                return
            }

            handleAnim()
        })

         function handleAnim() {
            section.find(".grid-item").each((idx, el) => {
                gsap.to($(el).find(".number span"), {
                    innerText: $(el).data("total"),
                    duration: 2,
                    ease: "power2.out",
                    snap: {
                        innerText: 1
                    }
                })
            })
        }
    })
})(jQuery);